import React from 'react';
import FeaturedImage from '../FeaturedImage';

function post(props) {
    const {
        post,
        postType,
        displayAuthor,
        displayExcerpt,
        displayDate,
        displayCategories,

        replaceSelected,
        theExcerpt,
    } = props;

    let categories;
    let categoryItems;
    let featuredImage;
    let author;
    let excerpt;
    let date;
    let tags = [];
    let tagsItems;

    if (
        post.hasOwnProperty('_embedded') &&
        post._embedded.hasOwnProperty('wp:featuredmedia')
    ) {
        featuredImage = (
            <a
                href={post.link}
                className="eight29-featured-image insight-card__image"
            >
                <figure>
                    <FeaturedImage
                        imageSize={'thumbnail-post'}
                        image={post._embedded['wp:featuredmedia']}
                        srcset={post.featured_image_srcset}
                    ></FeaturedImage>
                </figure>
            </a>
        );
    }

    if (
        post.hasOwnProperty('_embedded') &&
        post._embedded.hasOwnProperty('wp:term')
    ) {
        categories = post._embedded['wp:term'][0];
    }

    if (categories && displayCategories) {
        categoryItems = categories.map((category, index) => {
            return (
                <a
                    key={category.id}
                    onClick={() => {
                        replaceSelected(category.id, category.taxonomy);
                    }}
                >
                    {category.acf.icon && (
                        <span className={category.acf.icon} />
                    )}
                    <span dangerouslySetInnerHTML={{ __html: category.name }} />
                </a>
            );
        });
    }

    if (
        post.hasOwnProperty('_embedded') &&
        post._embedded['wp:term'][1].length
    ) {
        tags = [...post._embedded['wp:term'][1]];
    }

    if (
        post.hasOwnProperty('_embedded') &&
        post._embedded['wp:term'][2].length
    ) {
        tags = [...tags, ...post._embedded['wp:term'][2]];
    }

    if (tags.length) {
        tagsItems = tags.map((tag, index) => {
            return (
                <li className="terms-list__item" key={index}>
                    <a
                        key={tag.id}
                        onClick={() => {
                            replaceSelected(tag.id, tag.taxonomy);
                        }}
                        className="terms-list__link"
                    >
                        <span
                            dangerouslySetInnerHTML={{ __html: tag.name }}
                            className="terms__single"
                        />
                    </a>
                </li>
            );
        });
    }

    if (post.author && displayAuthor) {
        author = <span className="author">By {post.author}</span>;
    }

    if (post.custom_excerpt && displayExcerpt) {
        excerpt = (
            <div
                className="insight-card__excerpt"
                dangerouslySetInnerHTML={{
                    __html: theExcerpt(post.custom_excerpt, null, false),
                }}
            ></div>
        );
    }

    if (displayDate) {
        date = (
            <time className="insight-card__date">{post.formatted_date}</time>
        );
    }

    return (
        <article className="insight-card">
            <div className="insight-card__wrapper">
                <a href={post.link} className="insight-card__link" />
                <div className="insight-card__content">
                    <div className="insight-card__top">
                        {categoryItems && (
                            <>
                                <div className="insight-card__type">
                                    {categoryItems}
                                </div>
                                <div className="insight-card__divider"></div>
                            </>
                        )}
                        {date}
                    </div>
                    {featuredImage}
                    <h3
                        className="insight-card__title"
                        dangerouslySetInnerHTML={{
                            __html: post.title.rendered,
                        }}
                    />
                    {excerpt}
                    {tagsItems && (
                        <div className="insight-card__tags term-tag">
                            <ul className="terms-list">{tagsItems}</ul>
                        </div>
                    )}
                </div>
            </div>
        </article>
    );
}

export default post;
